import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { capi, apiError } from "@/lib/api";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription,
  AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export function RemoveRequestButton({ number, status, onRemoved }) {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const stop = (e) => { e.preventDefault(); e.stopPropagation(); };

  const confirm = async (e) => {
    stop(e);
    setBusy(true);
    try {
      await capi.post(`/account/requests/${number}/hide`);
      toast.success(`${number} removed from your list`);
      setOpen(false);
      onRemoved(number);
    } catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid={`remove-request-${number}`} onClick={(e) => { stop(e); setOpen(true); }}
        className="flex items-center gap-1.5 rounded-full border border-kys-blush-border px-3 py-1.5 text-xs font-medium text-kys-charcoal transition-colors hover:border-destructive hover:text-destructive">
        <Trash2 className="h-3.5 w-3.5" /> Remove
      </button>
    <AlertDialog open={open} onOpenChange={setOpen}>      <AlertDialogContent data-testid="remove-request-dialog" onClick={(e) => e.stopPropagation()}>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {number} from your list?</AlertDialogTitle>
          <AlertDialogDescription>
            This hides the request from My Custom Orders. Your request, messages and any payment records are kept — message us if you need it back.
            {status === "Approved" && " It's approved and ready to purchase — once removed you'll need the link in your approval email (or to message us) to buy it."}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="remove-request-cancel" onClick={(e) => { e.stopPropagation(); setOpen(false); }}>Keep it</AlertDialogCancel>
          <AlertDialogAction data-testid="remove-request-confirm" disabled={busy} onClick={confirm}
            className="bg-destructive text-white hover:bg-destructive/90">Remove</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
    </>
  );
}
